module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features features-home features-coins"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-three-quarters position-relative"
  }, [_c('div', {
    staticClass: "control is-medium is-expanded has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "inputsearch",
    staticClass: "input is-medium",
    attrs: {
      "id": "local-coin-search",
      "type": "text",
      "placeholder": "Search for answers"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, _vm.debounceInput],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.debounceInput.apply(null, arguments)
      }
    }
  }), _vm._m(0)]), _c('div', {
    staticClass: "is-flex top-article-container"
  }, [(_vm.type) ? _c('nav', {
    staticClass: "breadcrumb flex-1"
  }, [_c('ul', [_vm._m(1), (_vm.article && _vm.article.categorySlug) ? [_c('li', [_c('a', {
    attrs: {
      "href": '/support/category/' + _vm.article.categorySlug
    }
  }, [_vm._v(_vm._s(_vm.article.categoryTitle))])])] : _vm._e()], 2)]) : _vm._e(), (_vm.article && _vm.article.updated_at && !_vm.isLoading) ? _c('div', {
    staticClass: "has-text-right fs-13"
  }, [_c('div', {
    staticClass: "text-white-on-dark"
  }, [_vm._v("Last updated: " + _vm._s(_vm._f("fromNow")(_vm.article.updated_at)))]), _c('div', {
    staticClass: "text-white-on-dark"
  }, [_vm._v("Posted on: " + _vm._s(_vm._f("formatFullDate")(_vm.article.created_at)))])]) : _vm._e()]), _c('div', {
    staticClass: "category-container",
    class: {
      'is-loading': _vm.isLoading
    }
  }, _vm._l((_vm.categories), function(o) {
    return _c('div', {
      staticClass: "has-text-left"
    }, [_c('div', {
      staticClass: "category",
      style: ('top: ' + _vm.topWarningMessage + 'px;')
    }, [(_vm.type !== 'category') ? _c('a', {
      staticClass: "flex-1",
      attrs: {
        "href": '/support/category/' + o.slug
      }
    }, [_vm._v(_vm._s(o.title))]) : _c('span', {
      staticClass: "flex-1"
    }, [_vm._v(_vm._s(o.title))]), (_vm.type !== 'category' && !_vm.search) ? _c('a', {
      staticClass: "article-count",
      attrs: {
        "href": '/support/category/' + o.slug
      }
    }, [_c('span', {
      staticClass: "fs-12"
    }, [_vm._v("View all " + _vm._s(o.count) + " articles")])]) : _vm._e()]), _c('div', {
      staticClass: "articles-container column"
    }, [(!_vm.isLoading && _vm.search && o.articles.length === 0) ? _c('div', {
      staticClass: "articles"
    }, [_c('span', [_vm._v("No articles coincide with your search")])]) : _vm._e(), _c('div', {
      staticClass: "articles columns"
    }, _vm._l((o.articles), function(a) {
      return _c('a', {
        staticClass: "article-mini",
        attrs: {
          "href": '/support/article/' + a.slug
        }
      }, [_c('div', {
        staticClass: "article-inner"
      }, [_c('div', {
        staticClass: "article-title"
      }, [_c('span', [_vm._v(_vm._s(a.title))])]), _c('div', {
        staticClass: "article-content"
      }, [_c('span', [_vm._v(_vm._s(a.shortText))]), _c('div', {
        staticClass: "is-flex aic"
      }, [_vm._m(2, true), (o.show_posted_date) ? _c('div', {
        staticClass: "continue-reading fs-11"
      }, [_c('span', [_vm._v("Posted on " + _vm._s(_vm._f("formatDateSecond")(a.created_at)))])]) : _vm._e()])])])])
    }), 0), _c('div', {
      staticClass: "has-text-centered"
    }, [(_vm.type !== 'category' && !_vm.search) ? _c('a', {
      staticClass: "article-count",
      attrs: {
        "href": '/support/category/' + o.slug
      }
    }, [_c('span', {
      staticClass: "fs-12"
    }, [_vm._v("View all " + _vm._s(o.count) + " articles")])]) : _vm._e()])])])
  }), 0), (_vm.type === 'article' && !_vm.isLoading && _vm.article && _vm.article.html) ? _c('div', {
    staticClass: "full-article"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.article.html)
    }
  })]) : _vm._e(), (_vm.type === 'article' && _vm.noData) ? _c('div', {
    staticClass: "articles"
  }, [_c('span', [_vm._v("Article not found")])]) : _vm._e(), (_vm.type === 'category' && _vm.noData) ? _c('div', {
    staticClass: "articles"
  }, [_c('span', [_vm._v("Category not found")])]) : _vm._e()]), _c('div', {
    staticClass: "column is-one-quarter has-text-left contact-support right-column"
  }, [_c('div', {
    staticClass: "right-column-container",
    style: ('top: ' + (_vm.topWarningMessage + 20) + 'px;')
  }, [_c('p', {
    staticClass: "text-white-on-dark"
  }, [_vm._v("If you have any issue, question or suggestion contact us here:")]), _c('br'), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _c('br'), _c('div', {
    staticClass: "back-to-top button is-small",
    on: {
      "click": _vm.backToTop
    }
  }, [_vm._m(7), _c('span', [_vm._v("Back to top")])]), _c('br'), _c('br')])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-right"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/support"
    }
  }, [_vm._v("All")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "continue-reading flex-1"
  }, [_c('a', [_vm._v("Continue reading")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-10"
  }, [_c('div', [_vm._v("Email (Official Support Channel)")]), _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "mailto:support@unmineable.com"
    }
  }, [_c('b', [_vm._v("support@unmineable.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-10"
  }, [_c('div', [_vm._v("X (formerly Twitter)")]), _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "https://x.com/un_mineable",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("@un_mineable")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-10"
  }, [_c('div', [_vm._v("Instagram")]), _c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "https://instagram.com/unminable",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("@unminable")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-15"
  }, [_c('span', [_vm._v("Beware of impersonators, we have no official Telegram or Discord channels.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52e16fa5","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Support.vue
// module id = 381
// module chunks = 1